import type { ReactNode } from 'react'
import { useInView } from 'react-intersection-observer'

import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'
import { useScreenSizeUp } from 'hooks/useScreenSize'

interface Props {
  children: ReactNode
}

function CroSppCollapsedPackagesActivation({ children }: Props) {
  const isTabletUp = useScreenSizeUp('tablet')
  const canActivateExperiment = isTabletUp
  const [inViewRef, inView] = useInView({
    skip: !canActivateExperiment,
    threshold: 0.5,
  })

  useExperiment(Experiments.croSppCollapsedPackagesV2, {
    canActivate: canActivateExperiment && inView,
  })

  return <div ref={inViewRef}>{children}</div>
}

export default CroSppCollapsedPackagesActivation
